/// <reference path="../_references.ts"/>

module App.Appointments {
	import INgMap = angular.map.INgMap;
	import BottomDrawerService = App.Helpers.BottomDrawerService;
	type Status = 'Paused' | 'Started' | 'complete' | 'Dispatched' | 'Acknowledged' | 'Arrived';
	import AppointmentService = App.Appointments.AppointmentService;
	import TitleBarService = App.Helpers.TitleBarService;
	import DirectionsResult = google.maps.DirectionsResult;
	import LatLng = google.maps.LatLng;

	export class AppointmentController {
		map: App.Map = {
			center: "38.970096, -92.408691",
			zoom: 18,
			markers: [
				{
					id: 1,
					position: "38.970096, -92.408691"
				}
			]
		};

		selectedAppt: Appointment = null;
		pastAppts: Appointment[] = [];
		futureAppts: Appointment[] = [];
		activeAppts: Appointment[] = [];
		loadingAppts: {id: number, loading: boolean}[] = [];

		static $inject = [
			'$scope', '$state', '$timeout', '$stateParams','$log', 'NgMap', 'AppointmentService', 'SelectedAppointment',
			'BottomDrawerService', 'TitleBarService', 'ToastService', '$q', 'LocationService', 'PermissionService', 'TimeEventService',
		];

		constructor(
			private $scope: ng.IScope,
			private $state: ng.ui.IStateService,
			private $timeout: ng.ITimeoutService,
			private $stateParams: ng.ui.IStateParamsService,
			private $log: ng.ILogService,
			private NgMap: INgMap,
			public AppointmentService: AppointmentService,
			public SelectedAppointment: SelectedAppointment,
			private BottomDrawerService: BottomDrawerService,
			private TitleBarService: TitleBarService,
			protected ToastService: App.Utils.ToastService,
			public $q: ng.IQService,
			private LocationService: App.Helpers.LocationService,
			protected PermissionService: App.Helpers.PermissionService,
			protected TimeEventService: App.TimeEvent.TimeEventService
		) {
			let vm = this;

			TitleBarService.set('Home');

			vm.updateAppointmentsList().then(() => {
				SelectedAppointment.getAppointment().then((appointment) => {
					let found = vm.activeAppts.concat(vm.pastAppts).concat(vm.futureAppts).find((appt) => {
						return appt.id === appointment.id;
					});
					if (found) {
						vm.selectAppointment(appointment);
					} else {
						SelectedAppointment.clear();
					}
				});
			});
		}

		updateAppointmentsList(): ng.IPromise<void> {
			let vm = this;

			return vm.AppointmentService.fetchAll('current', { quiet: 1, show_summary: 1, show_tags: 1 })
				.then((response: ng.IHttpResponse<{
					today: Appointment[],
					past: Appointment[],
					future: Appointment[]
				}>) => {
					let appointments = response.data;

					if(vm.$stateParams.completedApptId) {
						let removeApptById = (apptArr: Appointment[]) => {
							let removedAppt = apptArr.findIndex((appt) => {
								return appt.id == vm.$stateParams.completedApptId;
							});

							if(removedAppt != -1) {
								apptArr.splice(removedAppt, 1);
							}

							return apptArr;
						}

						removeApptById(appointments.past);
						removeApptById(appointments.today);
						vm.SelectedAppointment.clear();
					}
					vm.activeAppts = appointments.today;
					vm.pastAppts = appointments.past;
					vm.futureAppts = appointments.future;

					vm.loadingAppts = [];

					vm.activeAppts.concat(vm.pastAppts).concat(vm.futureAppts).forEach((appt) => {
						vm.loadingAppts.push({
							id: appt.id,
							loading: false
						});

						if (appt.appointment_status == 'Started' || appt.appointment_status == 'Arrived') {
							appt.appointment_status = 'Paused';
						}
					});
				});
		}

		isComplete(status: Status) : boolean {
			return status === 'complete';
		}

		buttonStatus(status: Status) : string {
			switch(status) {
				case 'Paused':
				case 'Started':
				case 'Arrived':
					return 'Resume';
				case 'Dispatched':
					return 'Acknowledge';
				case 'Acknowledged':
					return 'Start';
				default:
					return 'Start';
			}
		}

		setMap(lat: string, long: string) : void {
			let vm = this;

			vm.map.center = lat + ' ' + long;
			vm.map.markers[0].position = lat + ' ' + long;
		}

		selectAppointment(appointment?: Appointment): void {
			const vm = this;

			if(appointment instanceof App.Appointments.SelectedAppointment && vm.SelectedAppointment.service_request !== null) {
				vm.selectedAppt = vm.SelectedAppointment;

				vm.setMap(vm.selectedAppt.service_request.service_address.latitude, vm.selectedAppt.service_request.service_address.longitude);
			} else if(angular.isDefined(appointment)) {
				vm.SelectedAppointment.set(appointment);
				vm.SelectedAppointment.getAppointment();

				vm.selectedAppt = vm.SelectedAppointment;

				if (angular.isDefined(vm.selectedAppt.service_request) && vm.SelectedAppointment.service_request !== null) {
					vm.setMap(vm.selectedAppt.service_request.service_address.latitude, vm.selectedAppt.service_request.service_address.longitude);
				} else {
					vm.setMap(appointment.service_request.service_address.latitude, appointment.service_request.service_address.longitude);
				}
			}
		}

		updateAppointment(curAppt: Appointment, newAppt: Appointment): boolean {
			var index = this.activeAppts.indexOf(curAppt);
			if (index !== -1) {
				this.activeAppts[index] = newAppt;
				return true;
			}

			index = this.pastAppts.indexOf(curAppt);
			if (index !== -1) {
				this.pastAppts[index] = newAppt;
				return true;
			}

			index = this.futureAppts.indexOf(curAppt);
			if (index !== -1) {
				this.futureAppts[index] = newAppt;
				return true;
			}

			return false;
		}

		progressAppointmentStatus(appointment: Appointment): void {
			const vm = this;
			let apptSet: any;

			apptSet = vm.SelectedAppointment.set(appointment);
			vm.selectedAppt = vm.SelectedAppointment;
			vm.setMap(vm.selectedAppt.service_request.service_address.latitude, vm.selectedAppt.service_request.service_address.longitude);

			var loadingAppt = vm.loadingAppts.find((obj) => {
				return obj.id == appointment.id;
			});
			vm.$q.all([apptSet]).then(() => {
				if (appointment.appointment_status == 'Dispatched') {
					loadingAppt.loading = true;
					vm.SelectedAppointment
						.updateAppointmentStatus('Acknowledged')
						.then((response) => {
							this.updateAppointment(appointment, response);
							appointment = response;
						})
					.catch((err) => this.ToastService.showError('Failed to update appointment: ', err))
					.finally(() => loadingAppt.loading = false);
				} else if (
					appointment.appointment_status == 'Acknowledged' ||
					appointment.appointment_status == 'Paused' ||
					appointment.appointment_status == 'Started' ||
					appointment.appointment_status == 'Arrived'
				) {
					loadingAppt.loading = true;

					vm.SelectedAppointment
						.updateAppointmentStatus('Started')
						.then(response => {
							this.updateAppointment(appointment, response);
							return appointment = response;
						})
						.then(() => this.TimeEventService.confirmLastEvent())
						.then(() => {
							if (appointment.appointment_status == 'Started') {
								if (vm.SelectedAppointment.getPhone(true, true) !== "No phone found") {
									vm.sendCustomerText('Started');
								} else {
									vm.$state.go('zipSolutions.home.appointment.overview');
								}
							}
						})
						.catch((err) => this.ToastService.showError('Failed to update appointment: ', err))
						.finally(() => loadingAppt.loading = false);
				}
			});
		}

		sendCustomerText(nextStatus: string) {
			const vm = this;

			vm.BottomDrawerService.open([
				{
					text: "Send text",
					icon: 'fas fa-mobile-alt fa-fw',
					fn: () => {
						vm.sendTextWithLocation(nextStatus);
						vm.$state.go('zipSolutions.home.appointment.overview');
					}
				},
				{
					text: "Do not send a text",
					icon: 'fas fa-times fa-fw',
					fn: () => {
						vm.$state.go('zipSolutions.home.appointment.overview');
					}
				}
			], true, false);
		}

		sendTextWithLocation(nextStatus: string) {
			const vm = this,
				address = vm.SelectedAppointment.service_request.service_address,
				TIME_MULTIPLIER = 1.2;

			if(address.latitude && address.longitude) {
				vm.$timeout(() => {
					this.LocationService.getLocation().then((coords) => {
						vm.map.markers[1] = {
							id: 2,
							latitude: coords.latitude,
							longitude: coords.longitude
						};

						vm.NgMap.getMap().then(function() {
							let directionsService = new google.maps.DirectionsService(),
								request = {
									origin: new google.maps.LatLng(
										coords.latitude,
										coords.longitude
									),
									destination: vm.getDestination(),
									travelMode: google.maps.TravelMode.DRIVING,
									optimizeWaypoints: true
								};

							directionsService.route(request, function(response: DirectionsResult) {
								const seconds = response.routes[0].legs[0].duration.value * TIME_MULTIPLIER,
									timeOfArrival = moment().add(seconds, 'seconds').format('hh:mm a');

								vm.SelectedAppointment.sendCustomerText(nextStatus, timeOfArrival);
							});
						});
					}, function() {
						vm.SelectedAppointment.sendCustomerText(nextStatus);
					});
				});
			} else {
				vm.SelectedAppointment.sendCustomerText(nextStatus);
			}
		}

		getDestination() {
			const vm = this;

			let marker = vm.map.markers[0],
				position,
				destination: LatLng;

			if(typeof marker.position === 'string') {
				position = marker.position.split(' ');
				destination = new google.maps.LatLng(parseFloat(position[0]), parseFloat(position[1]));
			} else {
				destination = new google.maps.LatLng(marker.latitude, marker.longitude);
			}

			return destination;
		}

		displayDate(appointment: Appointment): string {
			return moment(appointment.scheduled_date + ' ' + appointment.scheduled_time, 'YYYY-MM-DD HH:mm').format('ddd, MMM Do YYYY hh:mma');
		}

		displayShortDate(appointment: Appointment): string {
			return moment(appointment.scheduled_date, 'YYYY-MM-DD').format('dddd Do');
		}

		displayTime(appointment: Appointment): string {
			return moment(appointment.scheduled_time, 'HH:mm').format('hh:mma');
		}

		isLoading(appointment: Appointment): boolean {
			return this.loadingAppts.find((obj) => {
				return obj.id == appointment.id;
			}).loading;
		}
	}
}
